import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed

  useEffect(() => {
    // Returning from OAuth: AuthCallback exchanges the session_id and calls login()
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    if (!localStorage.getItem("fp_token")) {
      setUser(false);
      return;
    }
    api
      .get("/api/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("fp_token");
        setUser(false);
      });
  }, []);

  const login = (data) => {
    localStorage.setItem("fp_token", data.access_token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } catch {}
    localStorage.removeItem("fp_token");
    setUser(false);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/api/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
